import React from "react";
import Button from "../UI/Button/Button";
import BlackRightArrow from "../../icons/arrows/black-right-arrow.svg";
import * as styles from "./ProductCard.module.scss";
import { Link } from "gatsby";
import { motion } from "framer-motion";
import Loader from "../Loader/Loader";

const ProductCard = ({
  id,
  color = "red",
  productGroup = [],
  name,
  img,
  slug,
  product_code,
}) => {
  const variants = productGroup.map((product) => ({
    color: product.attributes.find((attr) => attr.name === "Color")?.value,
    slug: product.slug,
  }));

  const productLink = `/detalle/${
    productGroup[0]?.slug ? productGroup[0]?.slug : slug
  }`;


  return (
    <Link to={productLink} className={styles.productCard__link}>
      <motion.div className={styles.productCard__container}>
        <div className={styles.container_img}>
          {productGroup.length === 0 && img.length === 0 ? (
            <Loader />
          ) : (
            <img
              src={productGroup[0]?.images ? productGroup[0].images[0] : img}
              alt={productGroup[0]?.name ? productGroup[0]?.name : name}
              className={styles.img}
              width={200}
            />
          )}
        </div>

        <div className={styles.container_color}>
          {variants &&
            variants.map((variant, index) => (
              <div
                key={index}
                className={styles.block_color}
                style={{ backgroundColor: variant.color }}
              ></div>
            ))}
        </div>

        <h4 className={styles.productCard__name}>
          {productGroup.length !== 0 ? productGroup[0]?.name : name}
        </h4>
        <h5 className={styles.productCard__model}>
          {productGroup[0]?.product_code
            ? productGroup[0]?.product_code
            : product_code}
        </h5>

        <div className={styles.productCard__button}>
          <Button text="Ver más" colorCategory={color} icon={BlackRightArrow} />
        </div>
      </motion.div>
    </Link>
  );
};

export default ProductCard;
